import { FC } from "react";

import { PNG, SVG_MUI } from "@ryde/assets";
import { useApplication, useRtl } from "@ryde/redux";
import { useIsMobile } from "@ryde/shared";

import "./login.page.css";

import { LoginPageForm } from "./login.page.form";
import {
  CopyrightLine,
  LeftImageLogin,
  MainLoginContainerStyled,
} from "./login.page.styled";
import { useLoginTranslation } from "./use-login-translation";

export const LoginPage: FC = () => {
  const { isMobile } = useIsMobile();
  const { direction } = useRtl();
  const { t } = useLoginTranslation();
  const { isAdminApp } = useApplication();
  return (
    <MainLoginContainerStyled dir={direction}>
      {!isMobile && (
        <LeftImageLogin $isAdminApp={isAdminApp}>
          <SVG_MUI.LogoLoginSVG className="logo" />
          <img src={PNG.LoginLogoPNG} alt="logo" />
        </LeftImageLogin>
      )}
      <LoginPageForm />
      {!isMobile && (
        <CopyrightLine>
          <div>{t("ui.COPYRIGHT_INFO")} </div>
        </CopyrightLine>
      )}
    </MainLoginContainerStyled>
  );
};
